import { Flame } from "lucide-react";

export const HotProductBadge = () => {
  return (
    <div className="absolute -top-2 -left-2 z-10">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-red-500 rounded-full blur-md opacity-70 animate-pulse" />
        <div className="relative flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-orange-500 to-red-500 rounded-full text-white text-xs font-bold shadow-lg">
          <Flame className="w-3.5 h-3.5 animate-bounce" style={{ animationDuration: '0.5s' }} />
          HOT
        </div>
      </div>
    </div>
  );
};
